//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ModalWithTitleBar from '@/components/Shared/ModalWithTitleBar'
import DisparityTag from './DisparityTag.vue'
import checkIsMobileMixin from '~/mixins/checkIsMobileMixin.js'

export default {
  components: { ModalWithTitleBar, DisparityTag },
  mixins: [checkIsMobileMixin],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    collaborator: {
      type: Object,
      default: () => ({}),
    },
    supervisor: {
      type: Object,
      default: () => ({}),
    },
    skillPackValidations: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: this.value,
      sortableColumns: {
        collaborator_match: 'asc',
        supervisor_match: 'asc',
        disparity: 'asc',
      },
    }
  },
  computed: {
    supervisorName() {
      return `${this.supervisor.names} ${this.supervisor.lastnames}`
    },
    collaboratorName() {
      return `${this.collaborator.names} ${this.collaborator.lastnames}`
    },
  },
  watch: {
    value(newValue) {
      this.visible = newValue
    },
    visible(newValue) {
      this.$emit('input', newValue)
    },
  },
  methods: {
    onToggle() {
      this.visible = !this.visible
    },
    handleSort(field, order) {
      this.sortableColumns[field] = order
    },
  },
}
